module.exports = __webpack_public_path__ + "static/ff-landing-image-header-RT.613c7815.png";